module.exports = __webpack_public_path__ + "img/logo.3ae55961.png";